import Vue from 'vue'
import router from './router'
import store from './store'
import App from './App.vue'
import './registerServiceWorker'
import Functions from '@/components/Functions.js'
Vue.use(Functions)

import VueTour from 'vue-tour'
require('vue-tour/dist/vue-tour.css')
Vue.use(VueTour)

// import VueCardFormat from 'vue-credit-card-validation';
// Vue.use(VueCardFormat);

// Offline log books
//import VueOffline from "vue-offline";
//Vue.use(VueOffline);
//import OfflineLogBooksList from '@/components/OfflineLogBooksList'
//Vue.component('offline-log-books-list', OfflineLogBooksList)

// Shared Components
import CDSHeader from '@/components/CDSHeader'
Vue.component('cds-header', CDSHeader)
import CDSFooter from '@/components/CDSFooter'
Vue.component('cds-footer', CDSFooter)
import Loading from '@/components/Loading'
Vue.component('loading', Loading)
import ComponentModule from '@/components/ComponentModule'
Vue.component('component-module', ComponentModule)
import Pagination from '@/components/Pagination'
Vue.component('pagination', Pagination)
import PaginationDetail from '@/components/PaginationDetail'
Vue.component('pagination-detail', PaginationDetail)
import Message from '@/components/Message'
Vue.component('message', Message)
import MessageModal from '@/components/MessageModal'
Vue.component('message-modal', MessageModal)
import ToolTip from '@/components/ToolTip'
Vue.component('tool-tip', ToolTip)

// Async components only get loaded when needed
Vue.component(
    'template-section',
    // The `import` function returns a Promise.
    () => import('@/modules/website/components/TemplateSection')
)
Vue.component('list-component', () => import('@/components/ListComponent'))
Vue.component('list-view', () => import('@/components/ListView'))
Vue.component('menus', () => import('@/components/Menus'))
// Vue.component('message', () => import('@/components/Message'))

import draggable from 'vuedraggable'
Vue.component('draggable', draggable)

Vue.config.productionTip = false

// Vue.use(mapGetters)
// Vue.use(mapActions)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
